<template>
    <div class="hello">
        <h1>{{ msg }}</h1>
        <p class="subtitle">
            Notifikationer och varningar vid höga elpriser samt dagens elpriser.
        </p>
        <img alt="Vue logo" src="../assets/web2.png">
        <p class="subtitle">
            Elarm är en app där du kan välja att få notifikationer till din mobiltelefon vid höga elpriser. Du väljer själv vid vilket elpris du vill få en varning i form av notifikation.
        </p>
        <p class="subtitle">
            Notifikationen ger dig information om hur länge elpriset kommer vara över den valda nivån, exempelvis "Timpriset på el är just nu över 1kr/kWh och kommer att vara så från kl 13 till kl 21."
        </p>
        <p class="subtitle">
            Elarm ger dig även en snabb och enkel överblick över dagens elpriser samt elpriset just nu.
        </p>
        <h3>Kontakta mig som utvecklar Elarm</h3>
        <ul>
            <li><a href="mailto:christian.arby@gmail.com" target="_blank"
                   rel="noopener">christian.arby@gmail.com</a></li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'HelloWorld',
    props: {
        msg: String
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
    color: #D6FCFE;
}
.subtitle{
    color: aliceblue;
}

h3 {
    color: #D6FCFE;
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}
</style>
